module.exports = __webpack_public_path__ + "img/Hazy_Maze_cover.d676f947.png";